import { createFileRoute } from '@tanstack/react-router'
import { PartnersContent } from '@/features/content/partners/PartnersContent'
import { buildPartnerHead } from '@/lib/seo/staticPages'

export const Route = createFileRoute('/_layout/partner')({
  component: PartnersPage,
  head: () => buildPartnerHead(),
})

function PartnersPage() {
  return <PartnersContent />
}
